import { DadosComponentesProjeto, dadosComponentesProjetoValorDefault } from './DadosComponentesProjeto'
import { DadosMuros, dadosMurosValorDefault } from './DadosMuros'
import { DadosTipologia } from './Tipologia'
import { DadosLoteamentoComercial, dadosLoteamentoComercialValorDefault } from './DadosLoteamentoComercial'
import { Guid } from 'guid-typescript'

export type DadosDetalhamentoProjeto = {
  tipologias: DadosTipologia[]
  loteamentoComercial: DadosLoteamentoComercial
  componentesProjeto: DadosComponentesProjeto
  muros: DadosMuros
  id: Guid
}

export const dadosDetalhamentoProjetoValorDefault = {
  tipologias: [],
  loteamentoComercial: dadosLoteamentoComercialValorDefault,
  componentesProjeto: dadosComponentesProjetoValorDefault,
  muros: dadosMurosValorDefault,
  id: Guid.createEmpty()
} as DadosDetalhamentoProjeto
